import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ROUTES } from '../../common-files/enums/server-routes';

// media library (Configurations > Media) + the image picker used by the utsav forms.
// (HttpClient handles FormData for the upload; no Content-Type set here.)
@Injectable({ providedIn: 'root' })
export class MediaService {
  constructor(private http: HttpClient) {}

  listMedia(filters: { scope?: string; establishmentId?: number | null; category?: string; status?: string } = {}): Observable<any> {
    let params = new HttpParams();
    if (filters.scope) params = params.set('scope', filters.scope);
    if (filters.establishmentId) params = params.set('establishmentId', filters.establishmentId);
    if (filters.category) params = params.set('category', filters.category);
    if (filters.status === '0' || filters.status === '1') params = params.set('status', filters.status);
    return this.http.get(ROUTES.MEDIA_LIBRARY, { params });
  }

  // active central media + the establishment's own, for pickers
  listOptions(establishmentId: number | null, category?: string): Observable<any> {
    let params = new HttpParams();
    if (establishmentId) params = params.set('establishmentId', establishmentId);
    if (category) params = params.set('category', category);
    return this.http.get(ROUTES.MEDIA_OPTIONS, { params });
  }

  uploadMedia(file: File, fields: { scope: string; establishmentId: number | null; category: string; name: string; remarks?: string }): Observable<any> {
    const form = new FormData();
    form.append('file', file);
    form.append('scope', fields.scope);
    if (fields.establishmentId) form.append('establishmentId', String(fields.establishmentId));
    form.append('category', fields.category);
    form.append('name', fields.name);
    if (fields.remarks) form.append('remarks', fields.remarks);
    return this.http.post(ROUTES.MEDIA_LIBRARY, form);
  }

  updateMedia(mediaId: number, payload: { name: string; category: string; remarks?: string }): Observable<any> {
    return this.http.put(`${ROUTES.MEDIA}/${mediaId}`, payload);
  }

  setMediaStatus(mediaId: number, active: boolean): Observable<any> {
    return this.http.patch(`${ROUTES.MEDIA}/${mediaId}/status`, { active });
  }
}

// the categories offered in the library and pickers (free text in the table;
// this is the list the UI shows).
export const MEDIA_CATEGORIES = ['UTSAV', 'LOGO', 'BANNER', 'GALLERY', 'DOCUMENT'];
